import { Chip } from "@mui/material";

interface RoleBadgeProps {
    label: string;
    variant?: "filled" | "outlined";
}

const RoleBadge = ({ label, variant = "filled" }: RoleBadgeProps) => {
    return (
        <Chip
            label={label}
            size="small"
            variant={variant}
            sx={{
                fontSize: "12px",
                height: "24px",
                borderRadius: "12px",
                ...(variant === "filled"
                    ? {
                          backgroundColor: "var(--backgroundZ2, #f5f5f5)",
                          color: "var(--foreground, #1c1c1c)",
                          border: "none",
                      }
                    : {
                          backgroundColor: "transparent",
                          borderColor: "var(--border-grey, #e5e5e5)",
                          color: "var(--foreground, #1c1c1c)",
                      }),
            }}
        />
    );
};

export default RoleBadge;
